import { render, staticRenderFns } from "./NopCommerce.vue?vue&type=template&id=066b7740"
import script from "./NopCommerce.vue?vue&type=script&lang=js"
export * from "./NopCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports